var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBPipeDivider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-pipe-divider",
    x: 0.001,
    y: 0.001,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-pipe-divider1",
    serifid: "iconB-pipe-divider"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.001,2c0.562,0.001 0.999,0.472 0.999,1.028l-0.001,17.944c0,0.556 -0.437,1.028 -0.999,1.028c-0.563,0 -1,-0.472 -1,-1.028c0,0 0.002,-17.945 0.002,-17.942c-0.005,-0.557 0.436,-1.034 0.999,-1.03Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBPipeDivider);
export default __webpack_public_path__ + "static/media/iconB-pipe-divider.35be86aadc3048048ac9e87ff9028e64.svg";
export { ForwardRef as ReactComponent };